import createReducerExtended from 'utils/createReducerExtended';

import { userConstants } from '../constants';
import { initialState } from '../schema';
import * as reduceDeleteSession from './reduceDeleteSession';
import * as reduceReadUserProfile from './reduceReadUserProfile';
import * as reduceReadUserSession from './reduceReadUserSession';
import * as reduceRemoveNextRouteLocation from './reduceRemoveNextRouteLocation';
import * as reduceSetNextRouteLocation from './reduceSetNextRouteLocation';

export const reducer = (state = initialState, action) =>
  createReducerExtended(state, action, userConstants, {
    ...reduceDeleteSession,
    ...reduceReadUserProfile,
    ...reduceReadUserSession,
    ...reduceRemoveNextRouteLocation,
    ...reduceSetNextRouteLocation,
  });
